
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export const ExportHelper = {
    exportToExcel(items: any, fileName: any) {
        const fileType = "application/vnd.openxmlformats-officedocument-spreadsheetml.sheet;charset=UTF-8";
        const xlsxFileExtension = ".xlsx";

        const ws = XLSX.utils.json_to_sheet(items);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + xlsxFileExtension);
    },

    exportToCSV(items: any, fileName: any) {
        const cvFileExtension = ".csv";
        const dataToSheet = XLSX.utils.json_to_sheet(items);
        const dataFileCSV = XLSX.utils.sheet_to_csv(dataToSheet);
        let blob = new Blob(["\ufeff", dataFileCSV]);
        let data = new File([blob], "name");
        FileSaver.saveAs(data, fileName + cvFileExtension);
    }
}